import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { provinceDetailBreadcrumbsHistory } from './functions';

const ProvinceDetailBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="province-detail-breadcrumbs"
      history={provinceDetailBreadcrumbsHistory(t, location)}
    />
  );
};

export default ProvinceDetailBreadcrumbs;
